import { hasUrlProtocol } from "utils/regex";
import isEmail from "validator/lib/isEmail";
import isURL from "validator/lib/isURL";

export const validateEmails = (value: string) => {
  if (!value) {
    return;
  }
  const emails = [...value.split(/,\n?/)]; // Split comma-separated text into array. New lines are optional
  const errors = emails.filter((email) => !isEmail(email));
  if (errors.length) {
    return "Must be a valid email address or comma-separated list";
  }
};

export const validateWebhookUrl = (value: string) => {
  if (!value) {
    return;
  }
  if (hasUrlProtocol(value)) {
    if (
      !isURL(value, {
        require_protocol: true,
        require_tld: true,
      })
    ) {
      return "Must be a valid URL";
    }
  } else {
    return 'Must start with "https://" or "http://"';
  }
};

export const formatEmails = (emails: string): string[] | undefined => {
  const emailsArray = emails.split(/,\n?/);
  return emailsArray?.length
    ? [...emailsArray.filter((email) => !!email)]
    : undefined;
};
